// ========================================================
// FAST HIT Website — Footer
// ========================================================

import { Link } from 'react-router-dom';
import './Footer.css';

const FOOTER_SECTIONS = [
  {
    title: 'Cricket',
    links: [
      { to: '/live-scores', label: 'Live Scores' },
      { to: '/players', label: 'Players' },
      { to: '/teams', label: 'Teams' },
      { to: '/tournaments', label: 'Tournaments' },
    ],
  },
  {
    title: 'Product',
    links: [
      { to: '/features', label: 'Features' },
      { to: '/pricing', label: 'Pricing' },
      { to: '/download', label: 'Download App' },
      { to: '/contact', label: 'Contact' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { to: '/privacy', label: 'Privacy Policy' },
      { to: '/terms', label: 'Terms of Service' },
      { to: '/community-guidelines', label: 'Community Guidelines' },
    ],
  },
];

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer" role="contentinfo">
      <div className="footer__container">
        {/* Top: Brand + Links */}
        <div className="footer__grid">
          {/* Brand Column */}
          <div className="footer__brand">
            <Link to="/" className="footer__logo" aria-label="FAST HIT Home">
              <img src="/logo.png" alt="FAST HIT" className="footer__logo-img" />
              <span className="footer__logo-text">FAST HIT</span>
            </Link>
            <p className="footer__tagline">
              Every Ball. Every Match.<br />
              One Cricket Community.
            </p>
          </div>

          {/* Link Columns */}
          {FOOTER_SECTIONS.map((section) => (
            <div className="footer__section" key={section.title}>
              <h3 className="footer__section-title">{section.title}</h3>
              <ul className="footer__link-list">
                {section.links.map((link) => (
                  <li key={link.to}>
                    <Link to={link.to} className="footer__link">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <hr className="divider divider--glow" />

        {/* Bottom */}
        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} FAST HIT. All rights reserved.
          </p>
          <p className="footer__made">
            Made with 🏏 for cricket communities everywhere.
          </p>
        </div>
      </div>
    </footer>
  );
}
